// FlashCheck service pricing
export const FLASHCHECK_COST = 1; // 1 credit per FlashCheck request
